import { render, staticRenderFns } from "./BladeList.vue?vue&type=template&id=32268f40&"
import script from "./BladeList.vue?vue&type=script&lang=js&"
export * from "./BladeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports